import React from "react";

const ArrowUpInCircle = () => (
  <svg width="13" height="13" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fillRule="evenodd" clipRule="evenodd" d="M6.5 13a6.5 6.5 0 100-13 6.5 6.5 0 000 13zm.29-8.713L8.981 6.34l.407-.382L6.5 3.25 3.611 5.958l.408.382L6.21 4.287V9.75h.578V4.287z" fill="#FA928D" />
  </svg>
);

export default ArrowUpInCircle;
